const common = {
  title: "takkyuのブログ",
  indexTitle: 'メインページ',
  description: "C++などについて思いついたことを書きます。",
  postFooter: "間違いの指摘などコメントはtwitterやgithubまで頂けますと大変助かります🙇",
  minToRead: "分で読めます{{emoji}}",
}

export default common;
